<kal-form-field class="gup-C-formFieldSize--bottomNull" [class.without-label]="!shouldDisplayLabel">

    <ng-template kalFormFieldLabel>
        <ng-container *ngIf="shouldDisplayLabel">
            <ng-container *ngTemplateOutlet="labelTemplate ? labelTemplate : defaultLabelTemplate"></ng-container>
        </ng-container>
    </ng-template>

    <ng-template #defaultLabelTemplate>
        <span>{{fieldValue.label}}</span>
    </ng-template>

    <ng-container [ngSwitch]="fieldValue.type">

        <kal-input *ngSwitchCase="FieldValueTypes.Text" [formControl]="formControl"
        [type]="isFieldVisible ? 'text' : 'password'"></kal-input>

        <kal-input *ngSwitchCase="FieldValueTypes.Number" [formControl]="formControl" defaultValue="" [type]="isFieldVisible ? 'number' : 'password'"></kal-input>

        <kal-datepicker *ngSwitchCase="FieldValueTypes.Date" [formControl]="formControl"></kal-datepicker>

        <app-shared-searchbar-list
            #possibleFieldValueSearchbarListComponent
            (click)="possibleFieldValueSearchbarListComponent.setOptionValue()"
            *ngSwitchCase="FieldValueTypes.List"
            [formControl]="formControl">
            <kal-option *ngIf="shouldShowNoneOption" 
                        [value]="null">Aucun</kal-option>
            <kal-option *ngFor="let value of fieldValue.possibleValuesList"
                        [value]="value.Id">
                {{ value.Valeur }}
            </kal-option>
        </app-shared-searchbar-list>

        <div *ngSwitchCase="FieldValueTypes.Boolean">
            <kal-radio-group *ngIf="!forceSwitch else switchTemplate" [formControl]="formControl">
                <kal-radio value="1">Oui</kal-radio>
                <kal-radio value="0">Non</kal-radio>
            </kal-radio-group>
            <ng-template #switchTemplate>
                <div class="switchLabel">
                    <kal-checkbox [formControl]="formControl" kalTheme="switch">
                    </kal-checkbox>
                    <ng-container *ngTemplateOutlet="labelTemplate ? labelTemplate : defaultLabelTemplate">
                    </ng-container>
                </div>
            </ng-template>
        </div>

    </ng-container>

</kal-form-field>
